import React from "react";
import img from "../../assets/home/slider/imagen.png";
import "./HomeSlider.css";

const HomeSlider = () => {
  return (
    <div className="homeSlider mt-5 mb-3">
      <div className="container">
        <div className="row g-3">
          <div className="col-md text-slider d-flex flex-column justify-content-center align-items-center text-center">
            <p>Bienvenido a Strategic Partner Group (SPG)</p>
            <p>Somos el pilar que une y fortalece a las principales organizaciones en el sector de seguridad y vigilancia. Nuestro compromiso es proporcionar soluciones estratégicas, innovadoras y confiables que garanticen la protección y el bienestar de las personas y empresas.</p>
            <p>Descubre cómo trabajamos en conjunto para crear un entorno más seguro y eficiente. ¡Tu seguridad es nuestra prioridad! 🚀🔒</p>
          </div>
          <div className="col-md d-flex flex-column justify-content-center align-items-center text-center">
            <img src={img} alt="Imagen de presentacion" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { HomeSlider };